module.exports = "/images/vendor/flag-icon-css/flags/4x3/kp.svg?9c53429167b92e260e1ec30e1686b93b";